import {getPoliticalPartyIndex} from '@/api'

const actions = {
	async getPoliticalPartyData({commit}){
		let res = await getPoliticalPartyIndex()
			if(!res.code){
				commit('SAVE_PARTY_DATA',res.data)
			}else{
				alert(res.message)
			}
	}
}

const mutations = {
	SAVE_PARTY_DATA(state,data){
		state.politicalPartyData = data
		
	}
}

const state = {
	politicalPartyData:[],
	
}

const getters = {
	
}

export default {
	actions,
	mutations,
	state,
	getters
}